<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.subFolderName.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-12">
      {{ $t('message.abm.folders.settings.subFolderName.description') }}
    </p>
    <div class="documentCnfg__thumbnail flex">
			<div class="w-2/5">
				<div class="documentCnfg__bckg flex bg-zt-dark-300 justify-center items-center p-3 ">
					<template v-if="thumbnailArray.length">
            <div class="mx-2 rounded shadow overflow-hidden"
              :class="{'h-full' : orientationThumbnail}"
              v-for="(thumbnail, index) in thumbnailArray"
              :key="index"
            >
              <img
                alt=""
                :class="{
                  'h-full': orientationThumbnail,
                  'w-full': !orientationThumbnail
                }"
                :src="thumbnail"
              />
            </div>
          </template>
          <div v-else class="mx-2 rounded shadow bg-white h-40 w-32" />
				</div>
				<button class="documentCnfg__btn text-white w-full focus:outline-none bg-zt-primary-200" data-vs-button="configModal">
					<span class="flex justify-center">
						<em class="font-medium not-italic pl-1" @click="activeModal(true)">
              {{ $t('message.abm.folders.settings.subFolderName.configuration.label') }}
            </em>
					</span>
				</button>
			</div>
			<div class="w-3/5" v-if="applyConfig">
				<h2 class="custom-color-gray font-medium mb-4">
          {{ $t('message.abm.folders.settings.subFolderName.configuration.applied') }}
				</h2>
				<div v-for="item in stateFolder.subFolderParams.documentConfiguration.appliedConfig"
             :key="item.id"
             class="inline-block rounded py-2 pl-3 pr-3 mb-3 mr-3 items-center"
             :class="bgColorChipSignature(item.id)"
        >
					<zt-icon :name="item.icon" />
					<span class="ml-2">{{item.name}}</span>
				</div>
				<div class="custom-color-appliedConfig pt-3 underline font-medium">
					<a class="cursor-pointer" @click="activeModalDelete(true)" data-vs-link="nextPage">
            {{ $t('message.abm.folders.settings.subFolderName.configuration.deleteConfig') }}
          </a>
				</div>
			</div>
			<div class=" flex items-center justify-center" v-else>
					<div class="custom_border flex items-center w-4/5 text-center p-3">
						<zt-icon
							name="exclamation-circle-outline"
							class="text-gray-500"
							:style="{ fontSize: '4.5rem'}"
						/>
						<span class="span-4 text-gray-600">
              {{ $t('message.abm.folders.settings.subFolderName.configuration.notApplied') }}
            </span>
					</div>
			</div>
      <signature-modal-config ref="ztModalConfig" :active="active" />
			<delete-sub-folder-config-dialog :active="activeDeleteConfigDialog"/>
    </div>
  </div>
</template>
<script>
import Signature from '@/apiClient/Signature'
import SignatureModalConfig from "../signature/SignatureModalConfig";
import DeleteSubFolderConfigDialog from '@/modules/Folders/components/modals/DeleteSubFolderConfigDialog'
import { isEmpty, values, mapValues } from "lodash";

export default {
	name: 'SubFolderDocumentConfiguration',
  components: {
		SignatureModalConfig,
		DeleteSubFolderConfigDialog
  },
  inject: ['stateFolder','setPreviewConfiguration'],
  provide() {
    return {
	  	activeModal: this.activeModal,
			activeModalDelete: this.activeModalDelete
    }
  },
  data() {
    return {
			active: false,
			activeDeleteConfigDialog: false
    }
  },
  computed: {
    applyConfig() {
      return !isEmpty(this.stateFolder.subFolderParams.documentConfiguration.appliedConfig)
    },
    thumbnailArray() {
      return values(mapValues(this.stateFolder.subFolderParams.previewConfiguration, item => {
        return `data:image/jpeg;base64,${item}`
      }))
    },
    orientationThumbnail() {
      if(isEmpty(this.stateFolder.subFolderParams.documentConfiguration.orientation) && this.thumbnailArray.length === 1) {
        return true
      }
      return this.stateFolder.subFolderParams.documentConfiguration.orientation === 'P' && this.thumbnailArray.length === 1
    },
    bgColorChipSignature() {
      return itemId => {
        switch (itemId) {
          case 'signDef':
            itemId = 'custom-bg-employee'
            break
          case 'signEmp':
            itemId = 'custom-bg-employer'
            break
          default:
            itemId = 'bg-zt-dark-200'
        }
        return itemId
      }
    }
  },
  mounted() {
		this.setPreviewThumbnail()
  },
  methods: {
		activeModal(active) {
      this.$refs.ztModalConfig.$data.isLoading = true
			this.active = active
		},
	  activeModalDelete(active) {
	    this.activeDeleteConfigDialog = active
    },
    async setPreviewThumbnail() {
      this.signature = new Signature()
      try {
        const { id } = this.stateFolder.subFolderParams
        const previewConfiguration = await this.signature.getPreviewPositionImage(id)
        this.setPreviewConfiguration(previewConfiguration.data.data)
      }catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-input {
  ::v-deep {
    .zt-label {
      font-size: 1.125rem;
      margin: 0;
    }
    .zt-input {
      font-size: 1.125rem;
    }
  }
}
.custom-bg-employee {
  background-color: #D9F3EC;
  border: 1px solid #ADE2D2;
}
.custom-bg-employer {
  background-color: #CAC6E3;
  border: 1px solid #AEA7D5;
}
.custom_border{
	border: 2px solid #c7ccd2;
	border-radius: 0.5rem;
}
.documentCnfg__thumbnail {
	.documentCnfg__bckg {
	  width: 193px;
  	height: 165px;
  	border-radius: 5px 5px 0 0;
	}
	.documentCnfg__image {
  	border-radius: 5px;
  	border: 1px solid #888888;
		width: 108.68px;
		height: 127.03px;
	}
	.documentCnfg__btn {
	  width: 193px;
  	height: 56px;
  	border-radius: 0 0 5px 5px;
  	box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
	}
}
.custom-color-appliedConfig {
	color: #707070;
}
.custom-color-text-appliedConfig {
	color: #454545;
}
</style>
